import clsx from "clsx";
import { useEffect, useState } from "react";

import { presetImagesService } from "@/api/services/implementations/presetImages";
import { CameraNavigation } from "@/store/userLists/types";
import * as FullStory from "@/utilities/hooks/fullstory";


import ImgMediaCard from "../CameraCard/ImgMediaCard";
import classNames from "./Camera.scss";


interface CameraProps {
    camera: CameraNavigation;
    active?: boolean;
}

const Camera: React.FC<CameraProps> = ({ camera, active }) => {
    const [presignedUrl, setPresignedUrl] = useState<string>("");

    if (camera.thumbnailPreset) {
        useEffect(() => {
            presetImagesService
                .fetchPresetImagePresignedUrl(camera.thumbnailPreset!)
                .then((response) => {
                    setPresignedUrl(response.toString());
                })
                .catch((err) => console.log("PRESIGNED URL ERROR: ", err));
        }, [camera]);
    }

    return (
        <div className={clsx(classNames.imageCard, FullStory.names.classes.streaming.otherCamera)}>
            <ImgMediaCard
                cameraId={camera.id}
                unitName={camera.cameraName}
                health={camera.uptimeSummary}
                imageUrl={presignedUrl}
                active={active}
            />
        </div>
    );
};
export default Camera;
